import { ReportListItemStatus } from "~/api/model";

export const FINAL_REPORT_STATUSES = [
  ReportListItemStatus.completed,
  ReportListItemStatus.outdatedByDoclist,
  ReportListItemStatus.outdatedByTemplate,
  ReportListItemStatus.failed,
] as const;

export const EXPORTABLE_REPORT_STATUSES = [
  ReportListItemStatus.completed,
  ReportListItemStatus.outdatedByDoclist,
  ReportListItemStatus.outdatedByTemplate,
] as const;

type CryptoWithRandomUUID = {
  randomUUID: () => string;
};

const hasRandomUUID = (value: unknown): value is CryptoWithRandomUUID =>
  typeof value === "object" &&
  value !== null &&
  "randomUUID" in value &&
  typeof value.randomUUID === "function";

export function generateIdempotencyKey(): string {
  if (typeof crypto !== "undefined" && hasRandomUUID(crypto)) {
    return crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
